'use client';

import { useReportWebVitals } from 'next/web-vitals';

const report = ({ name, value }) => {
  if (['LCP', 'CLS', 'INP'].includes(name)) window.__pbPerfVital?.(name.toLowerCase(), value);
};

export default function WebVitals() {
  useReportWebVitals(report);
  return null;
}
